import { calcularImporteDeDescomposicion } from "utils/functions"

export const REFERENCE_PRICE_BANK = "BANCO DE PRECIOS REFERENCIA"
export const GRID_TAB_ORDER = [
  "type",
  "description",
  "quantity",
  "waste",
  "unity",
  "price",
]
export const EDIT_TAB_ORDER = [
  "description",
  "quantity",
  "waste",
  "unity",
  "price",
]

const toNumberOrZero = value => Number(value) || 0

export const getLegacyNormalizedQuantity = detail => {
  const originalQty = toNumberOrZero(detail.quantity)
  return detail.unity === "%" && originalQty > 1
    ? originalQty / 100
    : originalQty
}

export const getStoredQuantityFromInput = (quantity, unity) => {
  const parsedQuantity = toNumberOrZero(quantity)
  const normalizedInputQty =
    unity === "%" ? Math.min(Math.max(parsedQuantity, 0), 100) : parsedQuantity

  return unity === "%" ? normalizedInputQty / 100 : normalizedInputQty
}

export const resolveFactorAndWaste = ({ factor, waste, quantity }) => {
  let factorValue = factor
  let wasteValue = waste

  if (
    factorValue !== undefined &&
    factorValue !== null &&
    !Number.isNaN(Number(factorValue))
  ) {
    const quantityValue = toNumberOrZero(quantity)
    wasteValue = (Number(factorValue) - 1) * quantityValue
  } else {
    const wasteVal = toNumberOrZero(waste)
    const quantityValue = toNumberOrZero(quantity)
    factorValue = quantityValue !== 0 ? wasteVal / quantityValue + 1 : 1
    wasteValue = wasteVal
  }

  return { factorValue, wasteValue }
}

const buildReorderLabel = (description, emptyLabel) => {
  const trimmed = (description || "").trim()
  if (!trimmed) return emptyLabel
  return trimmed.length > 40 ? `${trimmed.slice(0, 40)}…` : trimmed
}

export const buildDetailGridRow = (detail, index, emptyLabel) => {
  const { factorValue, wasteValue } = resolveFactorAndWaste(detail)

  return {
    id: index,
    ...detail,
    factor: factorValue,
    waste: wasteValue,
    total: calcularImporteDeDescomposicion({ ...detail, total: undefined }),
    __reorder__: buildReorderLabel(detail.description, emptyLabel),
  }
}

export const buildUpdatedDetailRow = (newRow, oldRow) => {
  const storedQty =
    newRow.quantity !== oldRow.quantity
      ? getStoredQuantityFromInput(newRow.quantity, newRow.unity)
      : oldRow.quantity

  const wasteChanged = newRow.waste !== oldRow.waste
  const quantityChanged = newRow.quantity !== oldRow.quantity

  let factorValue = newRow.factor
  if (wasteChanged || quantityChanged) {
    const wasteValue = toNumberOrZero(newRow.waste)
    factorValue = storedQty !== 0 ? wasteValue / storedQty + 1 : 1
  }

  const rowForStore = {
    type: newRow.type || "",
    description: newRow.description || "",
    price: toNumberOrZero(newRow.price),
    priceReduced:
      newRow.priceReduced !== undefined
        ? newRow.priceReduced
        : oldRow.priceReduced,
    quantity: storedQty,
    waste: toNumberOrZero(newRow.waste),
    factor: factorValue,
    unity: newRow.unity || "pa",
    itemId: newRow.itemId,
    code: newRow.code ?? oldRow.code ?? "",
  }

  const rowForGrid = { ...newRow, quantity: storedQty, factor: factorValue }

  return {
    storedQty,
    factorValue,
    rowForStore,
    rowForGrid,
  }
}

export const isPartDetailsCellEditable = ({
  field,
  row,
  isTender,
  isReferencePriceBank,
}) => {
  if ((row.type === "coste" || row.unity === "%") && field === "priceReduced") {
    return false
  }

  if (row.itemId != null) {
    return field === "quantity" && !isTender && !isReferencePriceBank
  }

  if (field === "price") {
    return (
      !isTender &&
      !isReferencePriceBank &&
      row.type !== "coste" &&
      row.unity !== "%"
    )
  }

  if (
    ["description", "quantity", "waste", "priceReduced", "code"].includes(field)
  ) {
    return field === "quantity"
      ? !isTender && !isReferencePriceBank
      : !isReferencePriceBank
  }

  return false
}

export const getNextTabTarget = ({
  currentField,
  row,
  isTender,
  isReferencePriceBank,
  tabOrder = GRID_TAB_ORDER,
}) => {
  const currentIndex = tabOrder.indexOf(currentField)

  for (let i = currentIndex + 1; i < tabOrder.length; i++) {
    const nextField = tabOrder[i]

    if (nextField === "unity") {
      const isUnityDisabled =
        isTender || isReferencePriceBank || row.type === "coste"
      if (!isUnityDisabled) {
        return { field: nextField, action: "focus" }
      }
      continue
    }

    if (nextField === "type") {
      return { field: nextField, action: "focus" }
    }

    if (
      isPartDetailsCellEditable({
        field: nextField,
        row,
        isTender,
        isReferencePriceBank,
      })
    ) {
      return { field: nextField, action: "edit" }
    }
  }

  return null
}
